module.exports = __webpack_public_path__ + "img/ideas-workbench-primary.cedcc70b.svg";